@if (outPutFormat === 'localDate' || outPutFormat === 'localDateTime') {
  <span>
    {{ value ? value : ''}}
  </span>
}
@if (outPutFormat == undefined) {
  @if (type === 'compositeDate') {
    <span>
      {{setData(value, 'dateFormat')}}
      <!-- <ng-container *ngFor="let key of value">
      {{ key ? (key | dateFormat) : ''}}&nbsp;
    </ng-container> -->
  </span>
}
@if (type === 'compositeDatetime') {
  <span>
    {{setData(value, 'dateTimeFormat')}}
    <!-- <ng-container *ngFor="let key of value">
    {{ key ? (key | dateTimeFormat) : ''}} &nbsp;-
  </ng-container> -->
</span>
}
@if (type === 'compositeTime') {
  <span>
    {{ value ? (value | timeFormat) : ''}}
  </span>
}
@if (type === 'date') {
  <span>
    {{ value ? (value | dateFormat) : ''}}
  </span>
}
@if (type === 'datetime') {
  <span>
    {{ value ? (value | dateTimeFormat) : ''}}
  </span>
}
@if (type === 'time') {
  <span>
    {{ value ? (value | timeFormat) : ''}}
  </span>
}
}
<!-- <span *ngIf="type === 'array' || type === 'timeArray' || type === 'dateTimeArray'">
{{ value }}
</span> -->